import TextField from '@mui/material/TextField'

import { camelize } from '@/utils'

export default function WorkshopTitlePreview({ name = '' }: { name: string }) {
  if (!name) {
    console.error('Name not provided to <WorkshopTitlePreview />')
  }
  return (
    <TextField
      disabled
      helperText="This is the value that is stored in workshop"
      label="Workshop title"
      value={camelize(name) || ''}
    />
  )
}
